import { type FunctionComponent } from 'react';
import { type IconProps } from '../types';
import { IconWrapper } from '../style';

export const CheckCircle: FunctionComponent<IconProps> = ({
  color,
  rotation,
  width = '24px',
  height = '24px',
  cursor,
}: IconProps) => (
  <IconWrapper width={width} height={height} cursor={cursor}>
    <svg
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 25"
      fill="none"
      transform={`rotate(${rotation ?? 0})`}
    >
      <path
        d="M17.8142 9.70577C18.2948 9.22913 18.3066 8.44428 17.8406 7.95275C17.3745 7.46122 16.6071 7.44915 16.1265 7.92578L10.3034 13.7007L8.11686 11.5322C7.63625 11.0556 6.86884 11.0677 6.4028 11.5592C5.93676 12.0507 5.94856 12.8356 6.42917 13.3122L9.45959 16.3176C9.92978 16.7839 10.6771 16.7839 11.1473 16.3176L17.8142 9.70577Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1217 0C5.42707 0 0 5.42707 0 12.1217C0 18.8163 5.42707 24.2434 12.1217 24.2434C18.8163 24.2434 24.2434 18.8163 24.2434 12.1217C24.2434 5.42707 18.8163 0 12.1217 0ZM2.45158 12.1217C2.45158 6.78104 6.78104 2.45158 12.1217 2.45158C17.4623 2.45158 21.7918 6.78104 21.7918 12.1217C21.7918 17.4623 17.4623 21.7918 12.1217 21.7918C6.78104 21.7918 2.45158 17.4623 2.45158 12.1217Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  </IconWrapper>
);
